(() => {
  // Terraza Collective: el día avanza con el scroll. Fijado en escritorio; apilado en móvil y con movimiento reducido.
  const toMinutes = (time) => { const [h, m] = time.split(':').map(Number); return h * 60 + m; };

  const mount = (root) => {
    if (root.dataset.tzReady) return;
    const track = root.querySelector('[data-tz-track]');
    const stage = root.querySelector('[data-tz-stage]');
    const scenes = [...root.querySelectorAll('[data-tz-scene]')];
    if (!track || !stage || !scenes.length) return;
    root.dataset.tzReady = 'true';
    const labels = [...root.querySelectorAll('[data-tz-label-item]')];
    const tabs = [...root.querySelectorAll('[data-tz-tab]')];
    const plans = [...root.querySelectorAll('[data-tz-plan]')];
    const plansBox = root.querySelector('.tz-day__plans');
    const digits = [...root.querySelectorAll('.tz-day__digit')];
    const sky = root.querySelector('.tz-day__sky');
    const arc = root.querySelector('[data-tz-arc]');
    const sun = root.querySelector('[data-tz-sun]');
    const count = scenes.length;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const wide = window.matchMedia('(min-width: 1100px) and (min-height: 640px)');
    let current = -1;
    let pinned = false;
    let frame = 0;
    let plansInView = false;
    let sceneObserver = null;
    let plansObserver = null;

    root.style.setProperty('--tz-n', count);
    scenes.forEach((scene, index) => scene.style.setProperty('--k', index));

    const strike = () => {
      const now = current < 0 ? 0 : toMinutes(scenes[current].dataset.time);
      const show = pinned || plansInView;
      plans.forEach((plan) => plan.classList.toggle('is-cancelled', show && toMinutes(plan.dataset.tzPlan) <= now));
      root.classList.toggle('is-final', show && current === count - 1);
    };

    const setScene = (index) => {
      if (index === current) return;
      current = index;
      root.dataset.scene = String(index);
      root.classList.toggle('is-night', index === count - 1);
      scenes.forEach((scene, i) => {
        scene.classList.toggle('is-active', i === index);
        scene.classList.toggle('is-past', i < index);
      });
      labels.forEach((label, i) => label.classList.toggle('is-active', i === index));
      tabs.forEach((tab, i) => tab.setAttribute('aria-current', i === index ? 'true' : 'false'));
      const figures = scenes[index].dataset.time.replace(':', '').split('');
      digits.forEach((digit, i) => digit.style.setProperty('--d', figures[i] || '0'));
      strike();
    };

    const progress = () => {
      const top = parseFloat(getComputedStyle(stage).top) || 0;
      const distance = track.offsetHeight - stage.offsetHeight;
      return Math.min(1, Math.max(0, (top - track.getBoundingClientRect().top) / Math.max(distance, 1)));
    };

    const moveSun = (value) => {
      if (!sky || !arc || !sun) return;
      const point = arc.getPointAtLength(value * arc.getTotalLength());
      sun.style.setProperty('--sx', `${(point.x / 1000) * sky.clientWidth}px`);
      sun.style.setProperty('--sy', `${(point.y / 110) * sky.clientHeight}px`);
    };

    const update = () => {
      frame = 0;
      if (!pinned) return;
      const value = progress();
      moveSun(value);
      setScene(Math.min(count - 1, Math.floor(value * count)));
    };
    const onScroll = () => { if (!frame) frame = requestAnimationFrame(update); };

    const observeStacked = () => {
      sceneObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => { if (entry.isIntersecting) setScene(scenes.indexOf(entry.target)); });
      }, { rootMargin: '-42% 0px -42% 0px' });
      scenes.forEach((scene) => sceneObserver.observe(scene));
      if (plansBox) {
        plansObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            plansInView = true;
            setScene(count - 1);
            strike();
            plansObserver.disconnect();
          });
        }, { threshold: 0.6 });
        plansObserver.observe(plansBox);
      }
    };

    const mode = () => {
      const pin = wide.matches && !reduced.matches;
      if (sceneObserver) { sceneObserver.disconnect(); sceneObserver = null; }
      if (plansObserver) { plansObserver.disconnect(); plansObserver = null; }
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      pinned = pin;
      root.classList.toggle('is-pinned', pin);
      root.classList.toggle('is-stacked', !pin);
      if (pin) {
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll, { passive: true });
        update();
      } else {
        observeStacked();
      }
      strike();
    };

    tabs.forEach((tab) => tab.addEventListener('click', (event) => {
      if (!pinned) return;
      event.preventDefault();
      const index = Number(tab.dataset.tzTab);
      const top = parseFloat(getComputedStyle(stage).top) || 0;
      const distance = track.offsetHeight - stage.offsetHeight;
      const target = window.scrollY + track.getBoundingClientRect().top - top + ((index + 0.5) / count) * distance;
      window.scrollTo({ top: target, behavior: reduced.matches ? 'auto' : 'smooth' });
    }));

    root.classList.add('is-live');
    setScene(0);
    mode();
    wide.addEventListener('change', mode);
    reduced.addEventListener('change', mode);
  };

  const init = (scope) => scope.querySelectorAll('[data-tz-day]').forEach(mount);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
